module.exports = __webpack_public_path__ + "static/media/home_personal_folder.9e51ce4e.png";